import { render, staticRenderFns } from "./ProjectOwnerRequestNotification.vue?vue&type=template&id=7e08281c"
import script from "./ProjectOwnerRequestNotification.vue?vue&type=script&lang=ts"
export * from "./ProjectOwnerRequestNotification.vue?vue&type=script&lang=ts"
import style0 from "./ProjectOwnerRequestNotification.vue?vue&type=style&index=0&id=7e08281c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports